import { render, staticRenderFns } from "./SocketStatusAlert.vue?vue&type=template&id=bdccc536&scoped=true"
import script from "./SocketStatusAlert.vue?vue&type=script&lang=js"
export * from "./SocketStatusAlert.vue?vue&type=script&lang=js"
import style0 from "./SocketStatusAlert.vue?vue&type=style&index=0&id=bdccc536&prod&lang=scss&scoped=true"
import style1 from "./SocketStatusAlert.vue?vue&type=style&index=1&id=bdccc536&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdccc536",
  null
  
)

export default component.exports